import { render, staticRenderFns } from "./device_repair.vue?vue&type=template&id=6fafa248&scoped=true&"
import script from "./device_repair.vue?vue&type=script&lang=js&"
export * from "./device_repair.vue?vue&type=script&lang=js&"
import style0 from "./device_repair.vue?vue&type=style&index=0&id=6fafa248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fafa248",
  null
  
)

export default component.exports